var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-center"},_vm._l((_vm.languages),function(language){return _c('a',{key:language.lang_code,staticClass:"changeLanguage",on:{"click":function($event){return _vm.changeLanguage(language.lang_code)}}},[_c('i',{class:`flag-icon flag-icon-${language.flag_code}`}),_vm._v(" "+_vm._s(language.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }